import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { InternalUrlsServiceConfig } from '@rentigo/ngx-common';
import { AuthorizationConfig } from '@rentigo/ngx-authorization';
import { environment } from '../../../environments/environment';
import { Config } from '../config/config.model';
import { ConfigService } from '../config/config.service';

@Injectable({ providedIn: 'root' })
export class InitializationService {
  constructor(
    private configService: ConfigService,
    private internalUrlsServiceConfig: InternalUrlsServiceConfig,
    private authorizationConfig: AuthorizationConfig) { }

  initialize(): Promise<Config | undefined> {
    return this.configService
      .loadConfig()
      .pipe(
        tap(config => {
          environment.propertyManagerPortalBaseUrl = config.propertyManagerPortalBaseUrl;
          environment.payLaterUrl = config.payLaterUrl;
          environment.pspV1BaseUrl = config.pspV1BaseUrl;

          this.internalUrlsServiceConfig.apiBaseUrl = config.apiBaseUrl;

          this.internalUrlsServiceConfig.authorizationUrl = config.authorization.endpoint;
          this.authorizationConfig.applicationId = config.authorization.applicationId;
        })
      )
      .toPromise();
  }
}
